import type {ComponentProps} from 'react';
import type {Joyride} from 'react-joyride';

export const tourColors = {
  primaryColor: '#6545d9',
  textColor: '#29213f',
  backgroundColor: '#ede5ff',
  arrowColor: '#ede5ff',
};

export const tourStyles: ComponentProps<typeof Joyride>['styles'] = {
  arrow: {color: tourColors.arrowColor},
  floater: {filter: 'none'},
  tooltip: {
    background: tourColors.backgroundColor,
    border: 'none',
    borderRadius: 20,
    boxShadow: '0 12px 36px rgba(62, 38, 113, 0.18)',
    fontFamily: 'inherit',
    padding: 22,
  },
  tooltipContainer: {textAlign: 'left', background: 'transparent'},
  tooltipTitle: {
    color: '#442781', fontSize: 17, fontWeight: 700, lineHeight: 1.4,
    minHeight: 32, paddingRight: 40, margin: 0,
  },
  tooltipContent: {background: 'transparent', color: '#514367', fontSize: 14, lineHeight: 1.6, paddingTop: 8, paddingBottom: 4},
  tooltipFooter: {background: 'transparent', marginTop: 16, gap: 12},
  buttonPrimary: {
    backgroundColor: '#6545d9', color: '#fff', borderRadius: 12,
    fontFamily: 'inherit', fontSize: 14, fontWeight: 600, minHeight: 44, padding: '10px 18px',
  },
  buttonClose: {
    color: '#624393', background: 'transparent', border: 'none', borderRadius: '50%', boxShadow: 'none',
    top: 12, right: 12, width: 12, height: 12, minWidth: 44, minHeight: 44,
    boxSizing: 'border-box', padding: 16, margin: 0, lineHeight: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  buttonBack: {color: '#624393', fontFamily: 'inherit'},
  buttonSkip: {color: '#624393', fontFamily: 'inherit'},
};
